/* oxlint-disable react/refs -- imperative refs are required for DOM, focus, drag, and media behavior */
import { useEffect, useRef } from 'react'
import { subscribe } from 'app/lib/eventStream'
import type { StreamEvent } from 'app/lib/eventStream'

/**
 * Subscribes a component to events named `name` on the shared event stream for
 * as long as it is mounted and `enabled` is true. See `app/lib/eventStream` for
 * why every live surface shares one socket.
 *
 * The handler is held in a ref, so it always sees the latest render's values
 * without the subscription churning on every render. This only wires up the
 * subscription; opening the socket is `AppLayout`'s job, once an authenticated
 * user with a workspace is loaded.
 */
export function useEventStream(name: string, handler: (event: StreamEvent) => void, enabled = true): void {
  const handlerRef = useRef(handler)
  handlerRef.current = handler

  useEffect(() => {
    if (!enabled) return
    return subscribe(name, (event) => handlerRef.current(event))
  }, [name, enabled])
}
